import {
  getInternalMaterialProductName,
  isObject,
  SiteMaterialList,
  useApiTradeV1TradeCompaniesSiteMaterialsRetrieve,
} from 'api';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

type Props = Omit<AutocompleteFieldProps<SiteMaterialList>, 'options'> & {
  tradeCompanyId?: number;
  tradeSite?: number;
};

const getOptionLabel = (option: SiteMaterialList) => {
  if (isObject(option) && option.material_product) {
    return getInternalMaterialProductName(option.material_product);
  }

  // We shouldn't reach this point because we filter the options to have a material product
  // but we need to return a string for the defaultValue because we don't have the data
  // at initial render
  return 'No material product';
};

export const SiteMaterialWithProductAutocomplete = ({
  tradeCompanyId,
  tradeSite,
  required = false,
  ...rest
}: Props) => {
  const { data, isLoading } = useApiTradeV1TradeCompaniesSiteMaterialsRetrieve(
    tradeCompanyId || 0,
    {
      site: tradeSite,
    },
    {
      query: {
        enabled: Boolean(tradeCompanyId),
      },
    }
  );

  return (
    <AutocompleteField<SiteMaterialList>
      options={data?.results || []}
      loading={isLoading}
      getOptionLabel={getOptionLabel}
      groupBy={(option) => option.site.full_address}
      filterOptions={(options, _) => options.filter((option) => option.material_product)}
      data-testid="site-material-selector"
      disabled={!tradeCompanyId}
      valueField="id"
      required={required}
      {...rest}
    />
  );
};
